import { Link } from "react-router-dom";
import { games } from "@/mocks/games";

const categoryName: Record<string, string> = {
  campus: "校园纯爱", fantasy: "奇幻冒险", city: "都市职场", thriller: "悬疑惊悚",
  harem: "后宫多线", healing: "治愈日常", dark: "暗黑题材", world: "架空世界观",
};

export default function HotRanking() {
  const top = [...games].sort((a, b) => b.score - a.score).slice(0, 5);
  const featured = [...games].sort((a, b) => b.score - a.score)[0];

  return (
    <section className="bg-background-100/70">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-[1.5fr_1fr]">
        <div>
          <div className="flex items-end justify-between">
            <div>
              <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">Trending</p>
              <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
                本周口碑热议榜
              </h2>
            </div>
            <Link to="/ranking" className="inline-flex items-center gap-1 text-sm font-medium text-accent-700 hover:text-accent-600">
              全部排行 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="mt-8 divide-y divide-background-200/80">
            {top.map((g, i) => (
              <li key={g.id}>
                <Link
                  to={`/review/${g.id}`}
                  className="group flex items-center gap-4 py-4"
                >
                  <span className={`font-display w-9 shrink-0 text-center text-2xl font-black ${i === 0 ? "text-primary-500" : i === 1 ? "text-accent-500" : "text-secondary-500"}`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <img
                    src={g.cover}
                    alt={`${g.title} 封面`}
                    className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="truncate font-display text-base font-bold text-foreground-950 group-hover:text-accent-700">
                        {g.title}
                      </h3>
                      {g.isMasterpiece && (
                        <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium text-background-50">神作</span>
                      )}
                    </div>
                    <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span>{categoryName[g.category]}</span>
                      <span>·</span>
                      <span>{g.studio}</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-display text-xl font-black text-primary-600">{g.score.toFixed(1)}</div>
                    <div className="text-[10px] text-foreground-400">口碑分</div>
                  </div>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <div className="lg:pt-14">
          <Link
            to={`/review/${featured.id}`}
            className="group relative flex h-full min-h-[360px] flex-col justify-end overflow-hidden rounded-2xl"
          >
            <img
              src={featured.cover}
              alt={`编辑精选：${featured.title}`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
            <div className="relative p-6">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-star-smile-line"></i> 编辑精选
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-background-50">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-100/90">
                {featured.blurb}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-background-100/80">
                  {categoryName[featured.category]} · {featured.score.toFixed(1)} 分
                </span>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-300">
                  查看评测 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}